import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, map, Observable, Subject } from "rxjs";
import Swal from "sweetalert2";
import { ASSETS_PATH, AssignJobToVendor, ChangeQuotationStatus, CommonWebService, CreateVendor, DEVICE_CREDENTIALS, EditVendor, GenerateInvoice, GenerateInvoicePdf, HttpResponse, InvoiceDetail, ListVendorRating, MODIFIED_VENDOR_TYPE, QuotationList, RateVendor, RequestForQuotation, UserHttpService, VendorList, vendorReports, VendorTypeList, VENDOR_TYPE, ViewVendorProfile, ViewVendorRating } from "../public-api";

@Injectable({
    providedIn: 'root'
})
export class ManageVendorService {
    public vendorTypeList$: Subject<VendorTypeList[]> = new Subject<VendorTypeList[]>();
    public vendorDetail$: BehaviorSubject<VendorList | undefined> = new BehaviorSubject<VendorList | undefined>(undefined);
    public refreshVendorDetail$: Subject<boolean> = new Subject<boolean>();

    constructor(
        private http: HttpClient,
        private commonService: CommonWebService,
        private userService: UserHttpService
    ) {}
    
    public getVendorList(
        byName?: string,
        byLocation?: string,
        byType?: string
    ): Observable<HttpResponse<VendorList[]>> {
        let formData = new FormData();
        formData.append('user_id', this.userService.getUserInfo.user_id);
        formData.append('customer_id', this.userService.getUserInfo.usr_customer_track_id);
        formData.append('token', this.userService.userToken);
        formData.append('deviceToken', DEVICE_CREDENTIALS.DEVICE_TOKEN);
        formData.append('deviceType', DEVICE_CREDENTIALS.DEVICE_TYPE);
        formData.append('usr_role_track_id', this.userService.getUserInfo.user_id);
        formData.append("company_name", byName ? byName : '');
        formData.append("country", byLocation ?  byLocation : '');
        formData.append("vendor_type", byType ?  byType : '');
        // if(byName){
        //     formData.append("company_name", byName ? byName : '');
        // }
        // if(byLocation){
        //     formData.append("country", byLocation ?  byLocation : '');
        // }
        // if(byType){
        //     formData.append("vendor_type", byType ?  byType : '');
        // }
        return this.http.post<HttpResponse<VendorList[]>>('vendors/vendorList', formData).pipe(
            map((res) => {
                if(res && res.data && res.data.length > 0) {
                    res.data.forEach((ven) => {
                        ven.vendor_type = ven.vendor_type == VENDOR_TYPE.COMPANY ? MODIFIED_VENDOR_TYPE.COMPANY : MODIFIED_VENDOR_TYPE.INDIVIDUAL;
                    });
                    return res;
                } else {
                    return res;
                }
            })
        ); 
    }

    public getVendorDetail(vendor_id: string): Observable<HttpResponse<VendorList[]>> {
        let formData = new FormData();
        formData.append('user_id', this.userService.getUserInfo.user_id);
        formData.append('customer_id', this.userService.getUserInfo.usr_customer_track_id);
        formData.append('token', this.userService.userToken);
        formData.append('deviceToken', DEVICE_CREDENTIALS.DEVICE_TOKEN);
        formData.append('deviceType', DEVICE_CREDENTIALS.DEVICE_TYPE);
        formData.append('usr_role_track_id', this.userService.getUserInfo.user_id);
        formData.append('vendor_id', vendor_id ? vendor_id : "");
        return this.http.post<HttpResponse<VendorList[]>>('vendors/vendorDetail', formData);
    }

    public deleteVendor(id: string): Observable<HttpResponse<any>> {
        let formData = new FormData();
        formData.append('user_id', this.userService.getUserInfo.user_id);
        formData.append('customer_id', this.userService.getUserInfo.usr_customer_track_id);
        formData.append('token', this.userService.userToken);
        formData.append('deviceToken', DEVICE_CREDENTIALS.DEVICE_TOKEN);
        formData.append('deviceType', DEVICE_CREDENTIALS.DEVICE_TYPE);
        formData.append('usr_role_track_id', this.userService.getUserInfo.user_id);
        formData.append('vendor_id', id ? id : '');
        return this.http.post<HttpResponse<any>>('vendors/registerVendor/deleteVendor', formData);
    }

    public createVendor(body: CreateVendor, isEdit: boolean = false, id?: string): Observable<HttpResponse<VendorList[]>> {
        let formData = new FormData();
        formData.append('user_id', this.userService.getUserInfo.user_id);
        formData.append('customer_id', this.userService.getUserInfo.usr_customer_track_id);
        formData.append('token', this.userService.userToken);
        formData.append('deviceToken', DEVICE_CREDENTIALS.DEVICE_TOKEN);
        formData.append('deviceType', DEVICE_CREDENTIALS.DEVICE_TYPE);
        formData.append('usr_role_track_id', this.userService.getUserInfo.user_id);
        formData.append('vendor_type', body.vendor_type ? body.vendor_type : "");
        formData.append('first_name', body.first_name ? body.first_name : "");
        formData.append('last_name', body.last_name ? body.last_name : "");
        formData.append('mobile_number', body.mobile_number ? body.mobile_number : "");
        formData.append('email', body.email ? body.email : "");
        formData.append('street1', body.street1 ? body.street1 : "");
        formData.append('country', body.country ? body.country : "");
        formData.append('state', body.state ? body.state : "");
        formData.append('city', body.city ? body.city : "");
        formData.append('zipcode', body.zipcode ? body.zipcode : "");
        formData.append('uploadId', body.uploadId && body.uploadId ? typeof body.uploadId == 'string' ? this.commonService.getFormattedImageBase64(body.uploadId as string) : body.uploadId : "");
        formData.append('bank_account_name', body.bank_account_name ? body.bank_account_name : "");
        formData.append('account_no', body.account_no ? body.account_no : "");
        formData.append('bank_name', body.bank_name ? body.bank_name : "");
        formData.append('bank_country', body.bank_country ? body.bank_country : "");
        formData.append('currency', body.currency ? body.currency : "");
        formData.append('branch_code', body.branch_code ? body.branch_code : "");
        formData.append('routing_no', body.routing_no ? body.routing_no : "");
        formData.append('swift_code', body.swift_code ? body.swift_code : "");
        formData.append('iban_no', body.iban_no ? body.iban_no : "");
        formData.append('account_type', body.account_type ? body.account_type : "");
        formData.append('additional_info', body.additional_info ? body.additional_info : "");

        if(body.vendor_type == VENDOR_TYPE.INDIVIDUAL) {
            formData.append('company', body.company ? body.company : "");
            formData.append('vendor_type_id', body.vendor_type_id && body.vendor_type_id.vendor_type_id ? body.vendor_type_id.vendor_type_id : "");
        }
    
        if(body.vendor_type == VENDOR_TYPE.COMPANY) {
            formData.append('company_name', body.company_name ? body.company_name : "");
            formData.append('company_registration_number', body.company_registration_number ? body.company_registration_number : "");
            formData.append('company_type', body.company_type && body.company_type.vendor_type_id ? body.company_type.vendor_type_id : "");
            formData.append('vat_registration', body.vat_registration ? body.vat_registration : "");
            formData.append('designation', body.designation ? body.designation : "");
        }

        if(isEdit && id) {
            formData.append('vendor_individual_id', id ? id : "")
        }

        let url = isEdit && id  ? 'vendors/updateVendor' : 'vendors/registerVendor'
        return this.http.post<HttpResponse<VendorList[]>>(url, formData); 
    }



    //vendors type list api

    public vendorTypeList() {
        let formData = new FormData();
        formData.append('user_id', this.userService.getUserInfo.user_id);
        formData.append('customer_id', this.userService.getUserInfo.usr_customer_track_id);
        formData.append('token', this.userService.userToken);
        formData.append('deviceToken', DEVICE_CREDENTIALS.DEVICE_TOKEN);
        formData.append('deviceType', DEVICE_CREDENTIALS.DEVICE_TYPE);
        formData.append('usr_role_track_id', this.userService.getUserInfo.user_id);
        this.http.post<HttpResponse<VendorTypeList[]>>('vendors/listVendorType', formData).subscribe({
            next: ((res) => {
                this.vendorTypeList$.next(res.data.length > 0 ? res.data : []);
            }),
            error: ((err) => {
                console.log(err);
                Swal.fire("Oops...", err, "error");
            })
        }); 
    }

    public addVendorType(vendor_type: string): Observable<HttpResponse<any>> {
        let formData = new FormData();
        formData.append('user_id', this.userService.getUserInfo.user_id);
        formData.append('customer_id', this.userService.getUserInfo.usr_customer_track_id);
        formData.append('token', this.userService.userToken);
        formData.append('deviceToken', DEVICE_CREDENTIALS.DEVICE_TOKEN);
        formData.append('deviceType', DEVICE_CREDENTIALS.DEVICE_TYPE);
        formData.append('usr_role_track_id', this.userService.getUserInfo.user_id);
        formData.append('vendor_type', vendor_type ? vendor_type : "");
        formData.append('vendor_type_status', "1");
        return this.http.post<HttpResponse<any>>('vendors/addVendorType', formData);
    }

    public deleteVendorType(id: string): Observable<HttpResponse<any>> {
        let formData = new FormData();
        formData.append('user_id', this.userService.getUserInfo.user_id);
        formData.append('customer_id', this.userService.getUserInfo.usr_customer_track_id);
        formData.append('token', this.userService.userToken);
        formData.append('deviceToken', DEVICE_CREDENTIALS.DEVICE_TOKEN);
        formData.append('deviceType', DEVICE_CREDENTIALS.DEVICE_TYPE);
        formData.append('usr_role_track_id', this.userService.getUserInfo.user_id);
        formData.append('vendor_type_id', id ? id : "");
        return this.http.post<HttpResponse<any>>('vendors/addVendorType/delete_vendortype', formData);
    }


    //quotation
    public requestForQuotation(body: RequestForQuotation): Observable<HttpResponse<any>> {
        let formData = new FormData();
        formData.append('user_id', this.userService.getUserInfo.user_id);
        formData.append('customer_id', this.userService.getUserInfo.usr_customer_track_id);
        formData.append('token', this.userService.userToken);
        formData.append('deviceToken', DEVICE_CREDENTIALS.DEVICE_TOKEN);
        formData.append('deviceType', DEVICE_CREDENTIALS.DEVICE_TYPE);
        formData.append('usr_role_track_id', this.userService.getUserInfo.user_id);
        formData.append('vendor_id', body.vendor_id ? body.vendor_id : "");
        formData.append('vendor_typeid', body.vendor_typeid ? body.vendor_typeid : "");
        formData.append('quotation_requirement', body.quotation_requirement ? body.quotation_requirement : "");
        formData.append('expected_delivery', body.expected_delivery ? this.commonService.changeDateFormat(body.expected_delivery as Date) : "");
        formData.append('uploadId', body.uploadId ? body.uploadId : "");
        return this.http.post<HttpResponse<any>>('vendors/registerVendor/requestQuotation', formData);
    }

    public getQuotationList(id: string, status?: string): Observable<HttpResponse<QuotationList[]>> {
        let formData = new FormData();
        formData.append('user_id', this.userService.getUserInfo.user_id);
        formData.append('customer_id', this.userService.getUserInfo.usr_customer_track_id);
        formData.append('token', this.userService.userToken);
        formData.append('deviceToken', DEVICE_CREDENTIALS.DEVICE_TOKEN);
        formData.append('deviceType', DEVICE_CREDENTIALS.DEVICE_TYPE);
        formData.append('usr_role_track_id', this.userService.getUserInfo.user_id);
        formData.append('vendor_id', id ? id : "");

        if(status) {
            formData.append('quotation_status', status ? status : "");
        }
        return this.http.post<HttpResponse<QuotationList[]>>('vendors/registerVendor/quotataionList', formData);
    }

    public getQuotationDetail(id: string): Observable<HttpResponse<QuotationList[]>> {
        let formData = new FormData();
        formData.append('user_id', this.userService.getUserInfo.user_id);
        formData.append('customer_id', this.userService.getUserInfo.usr_customer_track_id);
        formData.append('token', this.userService.userToken);
        formData.append('deviceToken', DEVICE_CREDENTIALS.DEVICE_TOKEN);
        formData.append('deviceType', DEVICE_CREDENTIALS.DEVICE_TYPE);
        formData.append('usr_role_track_id', this.userService.getUserInfo.user_id);
        formData.append('quotation_id', id ? id : "");
        return this.http.post<HttpResponse<QuotationList[]>>('vendors/registerVendor/quotataionDetails', formData);
    }

    public changeQuotationStatus(body: ChangeQuotationStatus): Observable<HttpResponse<any>> {
        let formData = new FormData();
        formData.append('user_id', this.userService.getUserInfo.user_id);
        formData.append('customer_id', this.userService.getUserInfo.usr_customer_track_id);
        formData.append('token', this.userService.userToken);
        formData.append('deviceToken', DEVICE_CREDENTIALS.DEVICE_TOKEN);
        formData.append('deviceType', DEVICE_CREDENTIALS.DEVICE_TYPE);
        formData.append('usr_role_track_id', this.userService.getUserInfo.user_id);
        formData.append('quotation_id', body.quotation_id ? body.quotation_id : "");
        formData.append('vendor_id', body.vendor_id ? body.vendor_id : "");
        formData.append('quotation_status', body.quotation_status ? body.quotation_status : "");
        formData.append('quotation_comment', body.quotation_comment ? body.quotation_comment : "");
        formData.append('uploadId', body.uploadId ? body.uploadId : "");
        return this.http.post<HttpResponse<any>>('vendors/registerVendor/quotataionAcceptDecline', formData);
    }

    public quotationStatusHandler(quoationId: string, quotationStatus: string): Observable<HttpResponse<any>> {
        let formData = new FormData();
        formData.append('user_id', this.userService.getUserInfo.user_id);
        formData.append('customer_id', this.userService.getUserInfo.usr_customer_track_id);
        formData.append('token', this.userService.userToken);
        formData.append('deviceToken', DEVICE_CREDENTIALS.DEVICE_TOKEN);
        formData.append('deviceType', DEVICE_CREDENTIALS.DEVICE_TYPE);
        formData.append('usr_role_track_id', this.userService.getUserInfo.user_id);
        formData.append('quotation_id', quoationId ? quoationId : "");
        formData.append('quotation_status', quotationStatus ? quotationStatus : "");
        return this.http.post<HttpResponse<any>>('vendors/registerVendor/quotataionstatus', formData);
    }

    public assignJobToVendor(body: AssignJobToVendor): Observable<HttpResponse<any>> {
        let formData = new FormData();
        formData.append('user_id', this.userService.getUserInfo.user_id);
        formData.append('customer_id', this.userService.getUserInfo.usr_customer_track_id);
        formData.append('token', this.userService.userToken);
        formData.append('deviceToken', DEVICE_CREDENTIALS.DEVICE_TOKEN);
        formData.append('deviceType', DEVICE_CREDENTIALS.DEVICE_TYPE);
        formData.append('quotation_id', body.quotation_id ? body.quotation_id : "");
        formData.append('quotation_status', body.quotation_status ? body.quotation_status : "");
        formData.append('vendor_id', body.vendor_id ? body.vendor_id : "");
        return this.http.post<HttpResponse<any>>('vendors/registerVendor/assignJob', formData)
    }


    //give rating
    public rateVendor(body: RateVendor): Observable<HttpResponse<any>> {
        let formData = new FormData();
        formData.append('user_id', this.userService.getUserInfo.user_id);
        formData.append('customer_id', this.userService.getUserInfo.usr_customer_track_id);
        formData.append('token', this.userService.userToken);
        formData.append('deviceToken', DEVICE_CREDENTIALS.DEVICE_TOKEN);
        formData.append('deviceType', DEVICE_CREDENTIALS.DEVICE_TYPE);
        formData.append('usr_role_track_id', this.userService.getUserInfo.user_id);
        formData.append('vendor_id', body.vendor_id ? body.vendor_id : "");
        formData.append('vendor_type', body.vendor_type ? body.vendor_type : "");
        formData.append('charges_rating', body.charges_rating ? body.charges_rating : "");
        formData.append('quality_of_services_rating', body.quality_of_services_rating ? body.quality_of_services_rating : "");
        formData.append('responsiveness_rating', body.responsiveness_rating ? body.responsiveness_rating : "");
        formData.append('professionalism_rating', body.professionalism_rating ? body.professionalism_rating : "");
        formData.append('charges_comment', body.charges_comment ? body.charges_comment : "");
        formData.append('quality_of_services_comment', body.quality_of_services_comment ? body.quality_of_services_comment : "");
        formData.append('responsiveness_comment', body.responsiveness_comment ? body.responsiveness_comment : "");
        formData.append('professionalism_comment', body.professionalism_comment ? body.professionalism_comment : "");
        return this.http.post<HttpResponse<any>>('vendors/addVendorRating', formData)
    }

    //reviewVendorList
    public reviewVendorList(): Observable<HttpResponse<ListVendorRating[]>> {
        let formData = new FormData();
        formData.append('user_id', this.userService.getUserInfo.user_id);
        formData.append('customer_id', this.userService.getUserInfo.usr_customer_track_id);
        formData.append('token', this.userService.userToken);
        formData.append('deviceToken', DEVICE_CREDENTIALS.DEVICE_TOKEN);
        formData.append('deviceType', DEVICE_CREDENTIALS.DEVICE_TYPE);
        formData.append('vendor_individual_id', this.userService.getUserInfo.usr_team_track_id);
        
        
        return this.http.post<HttpResponse<ListVendorRating[]>>('vendors/listVendorRating', formData)
    }

    //View Vendor Rating
    public viewVendorRating(viewVendorRating: string): Observable<HttpResponse<ViewVendorRating[]>> {
        let formData = new FormData();
        formData.append('user_id', this.userService.getUserInfo.user_id);
        formData.append('customer_id', this.userService.getUserInfo.usr_customer_track_id);
        formData.append('usr_role_track_id', this.userService.getUserInfo.usr_role_track_id);
        formData.append('token', this.userService.userToken);
        formData.append('deviceToken', DEVICE_CREDENTIALS.DEVICE_TOKEN);
        formData.append('deviceType', DEVICE_CREDENTIALS.DEVICE_TYPE);
        formData.append('vendor_rating_id', viewVendorRating ? viewVendorRating : "");
        
        return this.http.post<HttpResponse<ViewVendorRating[]>>('vendors/viewVendorRating', formData)
    }

    //Vendor Reports
    public reportsVendor(report_frequency: string): Observable<HttpResponse<vendorReports>> {
        let formData = new FormData();
        formData.append('user_id', this.userService.getUserInfo.user_id);
        formData.append('customer_id', this.userService.getUserInfo.usr_customer_track_id);
        formData.append('token', this.userService.userToken);
        formData.append('deviceToken', DEVICE_CREDENTIALS.DEVICE_TOKEN);
        formData.append('deviceType', DEVICE_CREDENTIALS.DEVICE_TYPE);
        formData.append('vendor_id', this.userService.getUserInfo.usr_team_track_id);
        
        if(report_frequency) {
            formData.append('report_frequency', report_frequency ? report_frequency : "");
        }
        
        return this.http.post<HttpResponse<vendorReports>>('vendors/vendorReports', formData)
    }
    
    //invoice
    getInvoiceDetail(quotation_id: string): Observable<HttpResponse<InvoiceDetail[]>> {
        let formData = new FormData();
        formData.append('user_id', this.userService.getUserInfo.user_id);
        formData.append('customer_id', this.userService.getUserInfo.usr_customer_track_id);
        formData.append('token', this.userService.userToken);
        formData.append('deviceToken', DEVICE_CREDENTIALS.DEVICE_TOKEN);
        formData.append('deviceType', DEVICE_CREDENTIALS.DEVICE_TYPE);
        formData.append('vendor_id', this.userService.getUserInfo.usr_team_track_id);
        formData.append('quotation_id', quotation_id ? quotation_id : "");
        return this.http.post<HttpResponse<InvoiceDetail[]>>('vendors/generateInvoice', formData);
    }

    getInvoiceDetailCustomer(quotation_id: string, vendorId: string): Observable<HttpResponse<InvoiceDetail[]>> {
        let formData = new FormData();
        formData.append('user_id', this.userService.getUserInfo.user_id);
        formData.append('customer_id', this.userService.getUserInfo.usr_customer_track_id);
        formData.append('usr_role_track_id', this.userService.getUserInfo.usr_role_track_id);
        formData.append('token', this.userService.userToken);
        formData.append('deviceToken', DEVICE_CREDENTIALS.DEVICE_TOKEN);
        formData.append('deviceType', DEVICE_CREDENTIALS.DEVICE_TYPE);
        formData.append('usr_role_track_id', this.userService.getUserInfo.user_id);
        formData.append('vendor_id', vendorId ? vendorId : "");
        formData.append('quotation_id', quotation_id ? quotation_id : "");
        return this.http.post<HttpResponse<InvoiceDetail[]>>('vendors/generateInvoice/invoiceDetail', formData);
    }

    generateInvoice(body: GenerateInvoice): Observable<HttpResponse<any>> {
        let formData = new FormData();
        formData.append('user_id', this.userService.getUserInfo.user_id);
        formData.append('token', this.userService.userToken);
        formData.append('deviceToken', DEVICE_CREDENTIALS.DEVICE_TOKEN);
        formData.append('deviceType', DEVICE_CREDENTIALS.DEVICE_TYPE);
        formData.append('vendor_id', this.userService.getUserInfo.usr_team_track_id);
        formData.append('quotation_id', body.quotation_id ? body.quotation_id : "");
        formData.append('invoice_id', body.invoice_id ? body.invoice_id : "");
        formData.append('service_type', body.service_type ? body.service_type : "");
        formData.append('service_description', body.service_description ? body.service_description : "");
        formData.append('amount', body.amount ? body.amount : "");
        formData.append('tax', body.tax ? body.tax : "");

        if(body.invoice_doc) {
            formData.append('uploaddoc', body.invoice_doc ? typeof body.invoice_doc == 'string' ? this.commonService.getFormattedImageBase64(body.invoice_doc) : body.invoice_doc : "");
        }
        
        return this.http.post<HttpResponse<any>>('vendors/generateInvoice/sendinvoice', formData);
    }

    generateInvoicePdf(body: GenerateInvoicePdf): Observable<HttpResponse<{pdf_link: string}>> {
        let formData = new FormData();
        formData.append('user_id', this.userService.getUserInfo.user_id);
        formData.append('usr_customer_track_id', this.userService.getUserInfo.usr_customer_track_id);
        formData.append('token', this.userService.userToken);
        formData.append('customer_address', body.customer_address ? body.customer_address : "");
        formData.append('invoice_uniqueid', body.invoice_uniqueid ? body.invoice_uniqueid : "");
        formData.append('customer_company_name', body.customer_company_name ? body.customer_company_name : "");
        formData.append('customer_phone_no', body.customer_phone_no ? body.customer_phone_no : "");
        formData.append('order_id', body.order_id ? body.order_id : "");
        formData.append('createdOn', body.createdOn ? body.createdOn : "");
        formData.append('invoice_issueDate', body.invoice_issueDate ? body.invoice_issueDate : "");
        formData.append('company_name', body.company_name ? body.company_name : "");
        formData.append('first_name', body.first_name ? body.first_name : "");
        formData.append('last_name', body.last_name ? body.last_name : "");
        formData.append('mobile_number', body.mobile_number ? body.mobile_number : "");
        formData.append('vendor_address', body.vendor_address ? body.vendor_address : "");
        formData.append('servicetype_name', body.servicetype_name ? body.servicetype_name : "");
        formData.append('service_description', body.service_description ? body.service_description : "");
        formData.append('invoice_amount', body.invoice_amount ? body.invoice_amount : "");
        formData.append('invoice_tax', body.invoice_tax ? body.invoice_tax : "");
        formData.append('invoice_total', body.invoice_total ? body.invoice_total : "");

        return this.http.post<HttpResponse<{pdf_link: string}>>('vendors/generateInvoicePdf', formData);
    }
    //Vendor Detail Edit Profile
    
    public getVendorProfileDetail(): Observable<HttpResponse<ViewVendorProfile[]>> {
        let formData = new FormData();
        formData.append('user_id', this.userService.getUserInfo.user_id);
        formData.append('token', this.userService.userToken);
        formData.append('deviceToken', DEVICE_CREDENTIALS.DEVICE_TOKEN);
        formData.append('deviceType', DEVICE_CREDENTIALS.DEVICE_TYPE);
        formData.append('vendor_id', this.userService.getUserInfo.usr_team_track_id);
        formData.append('customer_id', this.userService.getUserInfo.usr_customer_track_id);
        return this.http.post<HttpResponse<ViewVendorProfile[]>>('vendors/registerVendor/vendorDetail', formData);
    }

    public updateVendorProfile(body: EditVendor): Observable<HttpResponse<any>> {
        let formData = new FormData();
        formData.append('user_id', this.userService.getUserInfo.user_id);
        formData.append('customer_id', this.userService.getUserInfo.usr_customer_track_id);
        formData.append('deviceToken', DEVICE_CREDENTIALS.DEVICE_TOKEN);
        formData.append('deviceType', DEVICE_CREDENTIALS.DEVICE_TYPE);
        formData.append('token', this.userService.userToken);
        formData.append('vendor_id', this.userService.getUserInfo.usr_team_track_id);

                
        formData.append('profilepicture', body.profilepicture ? typeof body.profilepicture == 'string' ? this.commonService.getFormattedImageBase64(body.profilepicture, ASSETS_PATH.VENDOR_ASSET) : body.profilepicture : "");
        
        formData.append('vendor_type', body.vendor_type ? body.vendor_type : "");
        formData.append('first_name', body.first_name ? body.first_name : "");
        formData.append('last_name', body.last_name ? body.last_name : "");
        formData.append('mobile_number', body.mobile_number ? body.mobile_number : "");
        formData.append('email', body.email ? body.email : "");
        formData.append('street1', body.street1 ? body.street1 : "");
        formData.append('street2', body.street2 ? body.street2 : "");
        formData.append('country', body.country ? body.country : "");
        formData.append('state', body.state ? body.state : "");
        formData.append('city', body.city ? body.city : "");
        formData.append('zipcode', body.zipcode ? body.zipcode : "");
        formData.append('uploadId', body.uploadId ? typeof body.uploadId == 'string' ? this.commonService.getFormattedImageBase64(body.uploadId, ASSETS_PATH.VENDOR_ASSET) : body.uploadId : "");

        //bank details
        formData.append('bank_account_name', body.bank_account_name ? body.bank_account_name : "");
        formData.append('account_no', body.account_no ? body.account_no : "");
        formData.append('bank_name', body.bank_name ? body.bank_name : "");
        formData.append('bank_country', body.bank_country ? body.bank_country : "");
        formData.append('currency', body.currency ? body.currency : "");
        formData.append('branch_code', body.branch_code ? body.branch_code : "");
        formData.append('routing_no', body.routing_no ? body.routing_no : "");
        formData.append('swift_code', body.swift_code ? body.swift_code : "");
        formData.append('iban_no', body.iban_no ? body.iban_no : "");
        formData.append('account_type', body.account_type ? body.account_type : "");


        if(body.vendor_type == VENDOR_TYPE.INDIVIDUAL) {
            formData.append('company', body.company ? body.company : "");
            formData.append('vendor_type_id', body.vendor_type_id ? body.vendor_type_id : "");
        }
    
        if(body.vendor_type == VENDOR_TYPE.COMPANY) {
            formData.append('company_name', body.company_name ? body.company_name : "");
            formData.append('company_registration_number', body.company_registration_number ? body.company_registration_number : "");
            formData.append('company_type', body.company_type && body.company_type ? body.company_type : "");
            formData.append('vat_registration', body.vat_registration ? body.vat_registration : "");
            formData.append('designation', body.designation ? body.designation : "");
        }


        return this.http.post<HttpResponse<any>>("vendors/registerVendor/vendorDataUpdate", formData);
    }

}